import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export class TranslationHttpLoader implements TranslateLoader {
    constructor(private httpClient: HttpClient,
                private i18nBaseUrl: string) {}

    public getTranslation(lang: string): Observable<Object> {
        lang = lang ? lang : 'es';
        return new Observable(observer => {
            this.httpClient.get(this.i18nBaseUrl + lang).subscribe(data => {
                observer.next(data);
                observer.complete();
            });
        });
    }
}
